import { FC } from 'react';
import { Typography } from '@mui/material';
import classNames from 'classnames';
import { ArrowBackButton } from 'components/shared';
import styles from './index.module.scss';

interface RadabankSectionHeaderProps {
	title: string;
	onClickBack?: () => void;
	className?: string;
}

export const RadabankSectionHeader: FC<RadabankSectionHeaderProps> = ({ title, className = '', onClickBack }) => (
	<div className={classNames(styles.content, className)}>
		<ArrowBackButton onClick={onClickBack} />
		<Typography variant="h6">{title}</Typography>
	</div>
);
